import { render, staticRenderFns } from "./location-select-type.vue?vue&type=template&id=a70e8538&scoped=true"
import script from "./location-select-type.vue?vue&type=script&lang=js"
export * from "./location-select-type.vue?vue&type=script&lang=js"
import style0 from "./location-select-type.vue?vue&type=style&index=0&id=a70e8538&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a70e8538",
  null
  
)

export default component.exports